import Banner from "../ui-components/Banner";
import Footer from "../ui-components/Footer";
import Header from "../ui-components/Header/Header";
import Sponser from "../ui-components/Sponser";


function LandingPage() {
  return (
    <div >
      {/* <Header/> */}
      <Banner/>
      {/* <Sponser/> */}
      {/* <Footer/> */}
    </div>
  );
}

export default LandingPage;
